export default {module:'Card/Form',view:'Element/Section',options:{xs:12,md:12,xl:12},children:[{config:'ui/text',options:{key:'list'}}]}